<div class="admin-container" [hidden]="!isLoaded">

  <mat-toolbar class="no-background">
    <span *ngIf="transaction">【管理者用】送金処理管理詳細（ID : {{transaction.id}}）</span>
    <span class="spacer"></span>
    <a mat-button class="add-link" routerLink="/admin/withdrawalTransaction">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>

  <div class="inquiry-container" *ngIf="transaction">

    <app-user-info
      [id]="transaction.inquiry?.id"
      [title]="transaction.inquiry ? transaction.inquiry.title : '単独の送金処理管理データ'"
      [name]="transaction.name"
      [login]="transaction.login"
      [status]="transaction.inquiry?.status"
      [priority]="transaction.inquiry?.priority"
      [user_id]="transaction.user_id"
      [email]="transaction.email"
    ></app-user-info>

    <form [formGroup]="adminForm" (ngSubmit)="onUpdate()" class="admin-form">

      <div class="form-flex">
        <div class="half-width">
          <div class="request">
            @if (transaction.inquiry) {
              <button mat-raised-button color="primary" type="button" (click)="inquiryLink(transaction.inquiry.id)">出金依頼の詳細画面を開く</button><br>
              <br>
              {{transaction.inquiry.first_child?.body}}
            }
            @else {
              【単独の送金処理として作成されました】<br>
              <br>
              {{transaction.alt_body}}
            }
          </div>
        </div>

        <mat-form-field appearance="outline" class="half-width" style="height: 100%;">
          <mat-label>管理者用メモ（非公開・4096文字まで）</mat-label>
          <textarea matInput formControlName="notes" rows="15" style="font-size: 14px;"></textarea>
          <mat-hint align="end">
            <span *ngIf="adminForm.get('notes')?.hasError('maxlength') && adminForm.get('notes')?.touched" class="inline-error">
              管理者用メモは4096文字以内で入力してください　
            </span>
            {{ adminForm.get('notes')?.value?.length || 0 }}/4096
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="form-row">
        <div class="amount">
          <ng-container *ngIf="!isEditingAmount; else editAmount">
            <span (click)="isEditingAmount = true" class="clickable">
              出金確定額：{{transaction.currency}} {{formatAmount(transaction.requested_amount, transaction.currency)}}
            </span>
          </ng-container>
          <ng-template #editAmount>
            出金確定額：{{transaction.currency}}
            <app-decimal-input
              formControlName="requested_amount"
              [scale]="transaction.currency === 'JPY' ? 0 : 2"
              [positiveOnly]="true"
              [inputStyle]="'width: 140px'">
            </app-decimal-input>
          </ng-template>
        </div>
        <div class="amount">
          送金済額：{{transaction.currency}} {{formatAmount(transaction.settled_amount, transaction.currency)}}
        </div>
        <div class="amount">
          未送金額：{{transaction.currency}} {{formatAmount(transaction.unpaid_amount, transaction.currency)}}
        </div>
        <div class="amount">
          <button mat-raised-button color="primary" type="submit" [disabled]="adminForm.invalid">
            {{isEditingAmount ? '出金確定額と管理者用メモを更新' : '管理者用メモを更新'}}
          </button>
        </div>
      </div>
    </form>

    <div class="details">
      <div style="font-size: 16px; font-weight: bold;">
        送金記録一覧
      </div>
      <table>
        <thead>
          <tr>
            <th>訂正</th>
            <th>ID</th>
            <th>送金日</th>
            <th>銀行への送金額 ({{transaction.currency}})</th>
            <th>送金手数料 ({{transaction.currency}})</th>
            <th>合計 ({{transaction.currency}})</th>
            <th>銀行側の振込処理番号等</th>
            <th>備考</th>
          </tr>
        </thead>
        <tbody>
          @if (transaction.details.length > 0) {
            <tr *ngFor="let detail of transaction.details;">
              <td class="detail-button"><button mat-raised-button color="primary" type="button" (click)="setFix(detail)">訂正</button></td>
              <td class="detail-id">{{detail.id}}</td>
              <td class="detail-date">{{formatDate(detail.transaction_date.toString(), true)}}</td>
              <td class="detail-amount">{{formatAmount(detail.amount_gross, transaction.currency)}}</td>
              <td class="detail-amount">{{formatAmount(detail.fee, transaction.currency)}}</td>
              <td class="detail-amount">{{formatAmount(detail.amount_net, transaction.currency)}}</td>
              <td class="detail-ref">{{detail.transaction_ref}}</td>
              <td class="detail-remarks">{{detail.remarks}}</td>
            </tr>
          }
          @else {
            <tr>
              <td colspan="8" style="text-align: center;">
                送金記録はありません
              </td>
            </tr>
          }
        </tbody>
      </table>

    </div>

    <div class="transaction-form">
      <form [formGroup]="form" (ngSubmit)="submit()">

        <div style="margin-bottom: 1em;">
          送金記録を{{(form.value.id > 0) ? '訂正' : '追加登録'}}する

          <span *ngIf="form.value.id > 0">
            【ID={{form.value.id}}】　
            <button mat-raised-button color="primary" type="button" style="margin-left: 2em; margin-top: -8px" (click)="formReset()">訂正を中止する</button>
          </span>
        </div>

        <mat-form-field appearance="outline" class="amount-width">
          <mat-label>送金日</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="transaction_date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint align="end">
            <span *ngIf="form.get('transaction_date')?.touched && form.get('transaction_date')?.invalid" class="inline-error">
              送金日を入力してください
            </span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="amount-width" style="margin-left: 1%;">
          <mat-label>銀行への送金額（{{transaction.currency}}）</mat-label>
          <input matInput appDecimalInput
              [scale]="transaction.currency === 'JPY' ? 0 : 2"
              type="text" inputmode="decimal" formControlName="amount_gross" (change)="calc()">
          <mat-hint align="end">
            <span *ngIf="form.get('amount_gross')?.touched && form.get('amount_gross')?.invalid" class="inline-error">
              送金額を入力してください
            </span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="amount-width" style="margin-left: 1%;">
          <mat-label>送金手数料（{{transaction.currency}}）</mat-label>
          <input matInput appDecimalInput
              [scale]="transaction.currency === 'JPY' ? 0 : 2"
              type="text" inputmode="decimal" formControlName="fee" (change)="calc()">
          <mat-hint align="end">
            <span *ngIf="form.get('fee')?.touched && form.get('fee')?.invalid" class="inline-error">
              手数料を入力してください
            </span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="amount-width" style="margin-left: 1%;">
          <mat-label>総額（送金額＋送金手数料）</mat-label>
          <input matInput appDecimalInput
              [scale]="transaction.currency === 'JPY' ? 0 : 2"
              type="text" inputmode="decimal" formControlName="amount_net" readonly>
          <mat-hint align="end">
            <span *ngIf="form.get('amount_net')?.hasError('exceedUnpaid')" class="inline-error">
              未送金額を超過しています
            </span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="amount-width" style="width: 28%; margin-left: 1%;">
          <mat-label>銀行側の振込処理番号等（50文字まで）</mat-label>
          <input matInput formControlName="transaction_ref" maxlength="50">
          <mat-hint align="end">
            <span *ngIf="form.get('transaction_ref')?.hasError('maxlength') && form.get('transaction_ref')?.touched" class="inline-error">
              50文字以内で入力してください
            </span>
            {{ form.get('transaction_ref')?.value?.length || 0 }}/50
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>この送金記録に関する備考（400文字まで）</mat-label>
          <textarea matInput formControlName="remarks" rows="2"></textarea>
          <mat-hint align="end">
            <span *ngIf="form.get('remarks')?.hasError('maxlength') && form.get('remarks')?.touched" class="inline-error">
              備考は400文字以内で入力してください　
            </span>
            {{ form.get('remarks')?.value?.length || 0 }}/400
          </mat-hint>
        </mat-form-field>

        <div style="text-align: right;">
          <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
            送金記録を{{(form.value.id > 0) ? '訂正' : '登録'}}
          </button>
        </div>

      </form>
    </div>
  </div>

</div>
